import { useEffect } from 'react';

// https://ybug.io
export const useYbug = (): void => {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `(function() {
        window.ybug_settings = {"id":"hmhykrdyadqv0cxj720s"};
        var ybug = document.createElement('script'); ybug.type = 'text/javascript'; ybug.async = true;
        ybug.src = 'https://widget.ybug.io/button/'+window.ybug_settings.id+'.js';
        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ybug, s);
    })();`;

    document.body.appendChild(script);

    return (): void => {
      document.body.removeChild(script);
    };
  }, []);
};
